
export function setToken(userToken) {
    sessionStorage.setItem('token', userToken);
    window.dispatchEvent(new CustomEvent('auth-token-changed'));
  }
  
export function getToken() {
    const token = sessionStorage.getItem('token');
    return token
  }
export function clearToken(){
    sessionStorage.clear()
    window.dispatchEvent(new CustomEvent('auth-token-changed'));
}
